import React, { useContext } from 'react';
import './AddTaskModal.css'; // Reuse modal styles
import { NotificationsContext } from '../context/NotificationsContext';

const TransferTaskModal = ({ open, onClose, employees = [], tasks = [] }) => {
  const { addNotification } = useContext(NotificationsContext);
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ minWidth: 700, maxWidth: 900, padding: 0 }}>
        <button className="modal-close" onClick={onClose}>&times;</button>
                  <div style={{ 
            background: 'linear-gradient(135deg, #6c757d 0%, #868e96 100%)',
            padding: '32px 32px 24px 32px',
            color: 'white',
            textAlign: 'center',
            position: 'relative'
          }}>
          <h2 className="modal-title">Transfer Task</h2>
          <div className="modal-subtitle">Add the required details for transferring the task</div>
        </div>
        <div style={{ padding: '32px 32px 120px 32px', background: '#fafbfc' }}>
        <div style={{ display: 'flex', gap: 24, marginTop: 24 }}>
          <form style={{ flex: 1, minWidth: 260 }}>
            <label style={{ display: 'block', marginBottom: 18 }}>
              <span className="label-row">Transfer From: <span className="required">*</span></span>
              <select required style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}>
                <option value="">Select Employee</option>
                {employees.map(emp => (
                  <option key={emp.id} value={emp.id}>{emp.name}</option>
                ))}
              </select>
            </label>
            <label style={{ display: 'block', marginBottom: 18 }}>
              <span className="label-row">Transfer To:</span>
              <select required style={{ width: '100%', padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}>
                <option value="">Select Employee</option>
                {employees.map(emp => (
                  <option key={emp.id} value={emp.id}>{emp.name}</option>
                ))}
              </select>
            </label>
          </form>
          <div style={{ flex: 2, minWidth: 320, background: '#fafbfc', border: '1px solid #eee', borderRadius: 8, padding: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 180 }}>
            {tasks.length === 0 ? (
              <span style={{ color: '#888', fontSize: 18 }}>No tasks available.</span>
            ) : (
              <ul style={{ width: '100%' }}>
                {tasks.map(task => (
                  <li key={task.id}>{task.title}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <div className="modal-submit-row" style={{ 
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          padding: '24px 32px 24px 32px',
          background: '#fff',
          borderBottomLeftRadius: '24px',
          borderBottomRightRadius: '24px',
          boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.08)',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <button 
            type="button" 
            className="modal-submit" 
            style={{ 
              minWidth: 200,
              background: 'linear-gradient(135deg, #6c757d 0%, #868e96 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '12px',
              padding: '16px 32px',
              fontSize: '1.1rem',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: '0 4px 16px rgba(108, 117, 125, 0.25)',
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseOver={e => {
              e.currentTarget.style.background = 'linear-gradient(135deg, #868e96 0%, #6c757d 100%)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(108, 117, 125, 0.35)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.background = 'linear-gradient(135deg, #6c757d 0%, #868e96 100%)';
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(108, 117, 125, 0.25)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            onMouseDown={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(108, 117, 125, 0.25)';
            }}
            onClick={() => {
              // In the current UI we don't have selected values or a backend call.
              // Fire a frontend notification to confirm transfer action.
              addNotification({
                type: 'task_assigned',
                title: 'Task reassigned',
                message: 'Task has been reassigned successfully.',
              });
              if (onClose) onClose();
            }}
          >
            Transfer Task
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default TransferTaskModal; 